import { useCreator } from "../creator/CreatorContext";
import { useSession } from "../auth/useSession";
import { Button, Display, Sprite, TierBadge } from "../design/primitives";
import { art } from "../design/sprites";
import css from "./account.module.css";

/**
 * §23. A full screen, not a modal. It names the patron's **real** tier and the
 * real cheapest tier that carries tabs - both read from the creator profile
 * (D-1). No hardcoded "8 Bit" or "$8" anywhere in this file.
 */
export default function Upgrade() {
  const { creator, me } = useCreator();
  const session = useSession();

  // The cheapest tier that is granted at least one slot of any asset type.
  const cheapestUnlocking = [...creator.tiers]
    .sort((a, b) => a.amountCents - b.amountCents)
    .find((tier) =>
      Object.values(creator.matrix).some((row) => row[tier.id] === true)
    );

  const price = (cents: number) =>
    `$${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)}`;

  return (
    <div className={css.upgrade}>
      <Sprite src={art.lock} size={150} />
      <Display size={52} lineHeight={1.08} as="h1">
        THIS ONE IS BEHIND A HIGHER TIER
      </Display>

      {me?.tier && (
        <div>
          <TierBadge name={me.tier.name} />
        </div>
      )}

      <p className={css.upgradeCopy}>
        {me?.tier
          ? `You are on ${me.tier.name}. `
          : "You are signed in but not backing a tier yet. "}
        {cheapestUnlocking
          ? `${cheapestUnlocking.name} at ${price(
              cheapestUnlocking.amountCents
            )} a month is the first tier that unlocks the tabs, and everything below it stays included.`
          : "No tier currently unlocks downloads."}
      </p>

      <Button
        variant="gold"
        size="landing"
        onClick={() =>
          window.open("https://www.patreon.com/user/membership", "_blank", "noopener")
        }
      >
        UPGRADE ON PATREON
      </Button>

      {session.isAuthenticated && (
        <button type="button" className={css.quiet} onClick={session.signOut}>
          Sign out
        </button>
      )}
    </div>
  );
}
